import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import useIndexSetFieldTypesAll from "views/logic/fieldactions/ChangeFieldType/hooks/useIndexSetFieldTypesAll";
const StyledLabel = styled.h5`
  font-weight: bold;
  margin-bottom: 5px;
`;
const StyledSelect = styled(Select)`
  width: 400px;
  margin-bottom: 20px;
`;
const FieldSelect = ({ indexSetId, field, name }) => {
  const { t } = useTranslation("search");
  const { setFieldValue } = useFormikContext();
  const {
    data: { options, currentTypes },
    isLoading
  } = useIndexSetFieldTypesAll(indexSetId);
  const _onFieldChange = useCallback(
    (value) => {
      setFieldValue(name, value);
      setFieldValue("field_type", currentTypes == null ? void 0 : currentTypes[value]);
    },
    [currentTypes, name, setFieldValue]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledLabel, null, t("change_field_type.select_field")), /* @__PURE__ */ React.createElement(Input, { id: name }, /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      inputId: name,
      name,
      options,
      value: field,
      onChange: _onFieldChange,
      placeholder: t("change_field_type.select_field_placeholder"),
      disabled: isLoading,
      "aria-label": t("change_field_type.select_field"),
      required: true,
      allowCreate: true
    }
  )));
};
export default FieldSelect;
